<div class="Flex--row Statistikmonitor">

    <div class="Flex--col Card hide-on-print" style="padding:20px;min-width:320px;max-width:320px">
        <h3>Themenbereich:</h3>


        <select v-model="category" class="Input">
            <option v-if="category==null" :value="null">Bitte wählen</option>
            <option v-for="category in getCategoriesWithIndicatorTypes(['R'])" :value="category">{{category}}</option>
        </select>


        <template v-if="category != null">


            <h3>Indikator:</h3>
            <select v-model="indicator" class="Input">
                <option v-if="indicator==null" :value="null">Bitte wählen</option>
                <option v-for="idc in getIndicators(category, indicatorType)" :value="idc">{{idc.name}}</option>
            </select>

            <template v-if="indicator != null">

                <p>
                    <Superbutton label="Glossar" icon="tivigi/img/question.svg" @click="openGlossary(getGlossaryLink(indicator.code))" alt="Glossar zum Themenbereich öffnen" title="Glossar zum Themenbereich öffnen" />
                </p>

                <p>
                    <Superbutton label="Drucken" icon="/img/print.svg" :set="true" @click="print()" />
                </p>
                <p style="margin-top:0px;font-size:0.9em">Empfohlen wird der Druck im Querformat.</p>

            </template>

        </template>

    </div>

    <div class="Flex--col Card" style="padding:20px">

        <h1 class="hide-on-screen">STATISTIKMONITOR Rhein-Neckar</h1>
        
        <template v-if="indicator == null">
            <h1>Strukturindikatoren</h1>

            <p class="Statistikmonitor__Description">Daten zum Vergleich der aktuellen Situation in den MRN-Teilräumen (Relativwerte)</p>
            <p class="Statistikmonitor__Hint">Bitte wählen Sie zuerst einen Themenbereich.</p>
        </template>
        
        <template v-else>

            <h2>{{indicator.name}}, {{getIndicatorDisplayDate(indicator,selectedYear)}}</h2>


            <div v-if="getYears(indicator.code).length > 1" class="InputGroup hide-on-print" style="margin:10px 0;">
                <Superbutton v-for="(year,index) in getYears(indicator.code)" :label="year" v-model="selectedYear" :set="year" :unset="selectedYear" />
            </div>

            <template v-if="selectedYear != null">

                <table class="Table">
                    <tr>
                        <th>Raumeinheit</th>
                        <th astyle="width:80%;"></th>
                        <th astyle="width:10%;" class="numeric">Wert</th>
                    </tr>

                    <tr v-for="su in getSpatialUnitsDefault()" :class="getCssClass(su)">
                        <td style="white-space: nowrap;">{{su.properties.name}}</td>

                        <td>
                            <BarDisplay style="width:100%" :value="getValue(su, indicator.code, selectedYear)" :max="max" min="0" />
                        </td>
                        <td class="numeric">
                            {{getValue(su, indicator.code, selectedYear) | formatNumber(indicator.decimal_places)}}
                        </td>

                    </tr>
                </table>

            </template>





        </template>
        
    </div>

</div>